(function () {
  'use strict';
  
  var languages = {
    "100":"NL",
    "-1":"EN",
    "-2":"FR",
    "-3":"DE",
    "-4":"IT",
    "-5":"ES",
    "-6":"PT",
    "-7":"ZH",
    "-9":"KO",
    "-11":"EU",
    "-12":"GA",
    "-13":"CA",
    "-14":"EL",
    "-20":"RU",
    "-21":"RO",
    "-22":"PL",
    "-27":"CS",
    "-28":"SK",
    "-30":"BG",
    "-33":"LT",
    "-34":"ET",
    "-35":"LV",
    "-38":"HR",
    "-39":"DA",
    "-40":"NO",
    "-43":"TR",
    "-44":"AR",
    "-36":"SL",
    "-26":"NL-BE",
    "-50":"ES-MX",
    "-15":"EN-US",
    "-32":"FR-CA",
    "-47":"UK"
    };

  inditex.enableGoogleAnalytics = function (){ };

  inditex.isExplorer = function () {
    var version;
    if(navigator.appName === 'Microsoft Internet Explorer'){
        var ieRegex = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
        if (ieRegex.exec(navigator.userAgent) !== null) {
            version = parseFloat(RegExp.$1);
        }
    } else if (navigator.appName === 'Netscape'){
        if (navigator.appVersion.indexOf('Trident') === -1) {
            version = 12;
        } else {
            version = 11;
        }
    }
    return version && version < 12; 
  }

  // ACTIVAR para dejar de navegar en Internet Explorer
  if(inditex.iPage != 'ItxBrowserNotSupportedPage' && inditex.isExplorer()){
      var country = inditex.iCountryCode.toLowerCase();
      var lang = languages[inditex.iLangId].toLowerCase();
      window.location.href = "https://" + inditex.iProxyHostStandard + "/" + country + "/" + lang + "/browser-not-supported.html";
  }

})();
